import { useTranslation } from 'react-i18next'

import { useManageTemplateDefault, TemplateLike } from './useManageTemplateDefault'

type UseRemoveDefaultTemplateProps = {
  removeDefaultTemplate: (templateId: string) => Promise<unknown>
  onRemoved: VoidFunction
}

export const useRemoveDefaultTemplate = <T extends TemplateLike>({
  removeDefaultTemplate,
  onRemoved
}: UseRemoveDefaultTemplateProps) => {
  const { t } = useTranslation()

  const { target, setTarget, isLoading, handleAction, success, closeSuccess } = useManageTemplateDefault<T>({
    action: removeDefaultTemplate,
    onSuccess: onRemoved,
    errorToastMessage: t('toast.templates.removeDefaultError')
  })

  return {
    templateToRemoveDefault: target,
    setTemplateToRemoveDefault: setTarget,
    isRemovingDefault: isLoading,
    handleRemoveDefault: handleAction,
    removeDefaultSuccess: success,
    closeRemoveDefaultSuccess: closeSuccess
  }
}
